import { Box } from '@mui/material';
import clsx from 'clsx';
import useScrollReveal from '../../hooks/useScrollReveal'; 

  export const ScrollMove = ({ children }) => {
    const [ref, isVisible] = useScrollReveal();

    return (
      <Box ref={ref} className= {clsx('fade-item', { 'is-visible': isVisible })} sx={{width:"100%"}}>
        {children}
      </Box>
    );
  };

  export const ScrollStatic = ({ children }) => {
    const [ref, isVisible] = useScrollReveal();

    return (
      <Box ref={ref} className= {clsx('fade-item-static', { 'is-visible': isVisible })} sx={{width:"100%"}}>
        {children}
      </Box>
    );
  };

  // className={`fade-item ${isVisible ? 'is-visible' : ''}`}
  // export default ScrollItem;